import React from 'react';
import BankLoanForm from './BankLoanForm';

export default function NBFCPersonalForm({ setScore, onComputed }) {
  return <BankLoanForm buttonLabel="Calculate Personal Loan Score" setScore={setScore} onComputed={onComputed} />;
}


